import { BookingFitDocumentConfig } from './booking-fit-document.types';

export const BOOKING_FIT_DOCUMENT_CONFIG: BookingFitDocumentConfig = {
  title: 'BUTTON.Download_Excel',
  routePath: 'booking-fit/document',
  defaultSort: 'id,desc',
  defaultPageSize: 100,
  documentTypes: [
    'room-booking-application',
    'room-change-application',
    'room-cancel-application',
    'room-final-confirmation',
  ],
};
